/**
 * header-collapse.js - to-lags mobil-header der kollapser til ét lag ved scroll
 * (eksperiment 9.4, inspireret af peakperformance.com).
 *
 * Udfoldet (top): raekke 1 er fuldt logo + search/cart/menu-ikonerne; raekke 2
 * er MEN/WOMEN-koensvaelgeren nedenunder. Ved scroll saettes [data-collapsed]
 * paa headeren, og CSS krymper baren til raekke 1 alene: koensvaelgeren fader
 * ud, mens det fulde logo og ikonerne staar fast (ingen top-shift).
 *
 * Progressiv forbedring: uden JS staar headeren udfoldet og virker fuldt ud.
 * Ren IntersectionObserver (ingen scroll-listener) - to usynlige sentineller
 * danner en dead-zone (hysterese): baren KOLLAPSER foerst naar man scroller
 * forbi COLLAPSE_Y, og EKSPANDERER foerst naar man er tilbage over EXPAND_Y.
 * Mellem de to graenser holdes tilstanden, saa en scroll der hviler omkring
 * skiftepunktet ikke kan toggle baren frem og tilbage. Kun aktiv < 834px;
 * teardown paa desktop, saa den sticky/absolutte desktop-header er helt uroert.
 */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header || !('IntersectionObserver' in window)) return;

  // Dead-zone: kollaps ved 80px scroll, ekspandér foerst tilbage ved 40px.
  var COLLAPSE_Y = 80;
  var EXPAND_Y = 40;

  var mq = window.matchMedia('(max-width: 833.98px)');
  var io = null;
  var collapseSentinel = null;
  var expandSentinel = null;

  function makeSentinel(topPx) {
    var el = document.createElement('div');
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText =
      'position:absolute;left:0;width:1px;height:1px;pointer-events:none;top:' + topPx + 'px;';
    document.body.prepend(el);
    return el;
  }

  function enable() {
    if (io) return;
    // to 1px-sentineller forankret i dokumentets top. collapseSentinel forlader
    // viewporten ved COLLAPSE_Y scroll -> kollaps; expandSentinel kommer tilbage
    // ind ved EXPAND_Y scroll -> ekspandér. Mellem dem sker intet (dead-zone).
    collapseSentinel = makeSentinel(COLLAPSE_Y);
    expandSentinel = makeSentinel(EXPAND_Y);
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === collapseSentinel && !entry.isIntersecting) {
            header.setAttribute('data-collapsed', '');
          } else if (entry.target === expandSentinel && entry.isIntersecting) {
            header.removeAttribute('data-collapsed');
          }
        });
      },
      { threshold: 0 },
    );
    io.observe(collapseSentinel);
    io.observe(expandSentinel);
  }

  function disable() {
    if (io) {
      io.disconnect();
      io = null;
    }
    if (collapseSentinel) {
      collapseSentinel.remove();
      collapseSentinel = null;
    }
    if (expandSentinel) {
      expandSentinel.remove();
      expandSentinel = null;
    }
    header.removeAttribute('data-collapsed');
  }

  function sync() {
    if (mq.matches) enable();
    else disable();
  }

  sync();
  mq.addEventListener('change', sync);
})();
